import React, { useEffect, useState } from "react";
import Form from "../../../components/Form";
import heroBg from "../../../images/hero-bg-new.webp";
import { useFormContext } from "../../../context/FormContext";

export default function HeroSection() {
  const {
    pickup,
    setPickupDate,
    setDropoffDate,
    setPickupTime,
    setDropoffTime,
    setPickup,
    setDropoff,
    setPickupGDSCode,
    setDropOffGDSCode,
    setPickupLocationObj,
    setDropoffLocationObj,
  } = useFormContext();
  const [cleared, setCleared] = useState(false);

  useEffect(() => {
    const navEntries = window.performance.getEntriesByType("navigation");
    const isRefresh = navEntries.length > 0 && navEntries[0].type === "reload";
    const comingFromResults = sessionStorage.getItem("returningFromSearch");
    // console.log("isRefresh:", isRefresh);
    // console.log("comingFromResults:", comingFromResults);
    // console.log("pickup in context at this point:", pickup);
    if ( !comingFromResults) {
      localStorage.removeItem("form_pickup");
      localStorage.removeItem("form_pickupLocationObj");
      localStorage.removeItem("form_pickupGDSCode");
      localStorage.removeItem("form_dropoff");
      localStorage.removeItem("form_dropoffLocationObj");
      localStorage.removeItem("form_dropOffGDSCode");
      localStorage.removeItem("form_pickupDate");
      localStorage.removeItem("form_dropoffDate");
      localStorage.removeItem("form_pickupTime");
      localStorage.removeItem("form_dropoffTime");

      setPickup("");
      setDropoff("");
      setPickupDate("");
      setDropoffDate("");
      setPickupTime("10:00");
      setDropoffTime("10:00");
      setPickupGDSCode("");
      setDropOffGDSCode("");
      setPickupLocationObj(null);
      setDropoffLocationObj(null);
    }

    sessionStorage.removeItem("returningFromSearch");
    setCleared(true); // ← always set, whether cleared or not
  }, []);

  return (
    <section className="relative w-full flex flex-col">
      {/*
        Background image wrapper.
        - Mobile: a normal block element with a fixed height (banner), NOT absolutely
          positioned, so it sits above the form card instead of stretching behind it.
        - Desktop (md+): unchanged — absolutely positioned to fill the whole section
          so text + form can sit on top of it.
      */}
      <div
        className="relative h-[320px] md:absolute md:inset-0 md:h-auto z-0"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* was: <div className="absolute inset-0 bg-black/40" /> */}
    <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/5 to-transparent" />

        {/*
          On mobile, the headline/badge/subtext live INSIDE the image banner
          (absolutely positioned over it), since the image is no longer the
          full section background. On desktop this inner copy is hidden,
          because the same content is rendered in the flow below for desktop.
        */}
        <div className="relative md:hidden z-10 flex flex-col items-start px-6 pt-24 h-full">
          <div className="mb-3">
            <span
              className="text-[10px] font-semibold tracking-widest uppercase
              text-white border border-white/40 bg-white/10
              px-2.5 py-1 rounded-full"
            >
              Car Rentals, Made Smarter
            </span>
          </div>

          <h1 className="font-heading font-bold text-white mb-2 text-xl leading-snug">
            Hit the road.
            <br />
            <span className="text-primary">For less.</span>
          </h1>

          <p className="font-body text-white/80 text-xs mb-6 max-w-xl">
            Top car rental brands. Best prices. Transparent deals. Total peace
            of mind.
          </p>
        </div>
      </div>

      {/*
        Desktop content (text over image + form near bottom) — exactly as before.
        Hidden on mobile since that copy now renders inside the banner above,
        and the form is rendered separately as its own card below.
      */}
      <div
        className="hidden md:relative md:flex md:flex-col md:items-start
        md:px-6 md:pt-24 md:pb-16 md:max-w-7xl md:mx-auto md:w-full z-10"
      >
        <div className="mb-4">
          <span
            className="text-xs font-semibold tracking-widest uppercase
            text-white border border-white/40 bg-white/10
            px-3 py-1 rounded-full"
          >
            Car Rentals, Made Smarter
          </span>
        </div>

        <h1
          className="font-heading font-bold text-white mb-3
  text-5xl lg:text-6xl leading-tight"
        >
          Hit the road
          <span className="font-sans">.</span>
          <br />
          <span className="text-primary">
            For less
            <span className="font-sans">.</span>
          </span>
        </h1>

        <p className="font-body text-white/80 text-md mb-8 max-w-xl">
          Top car rental brands. Best prices. Transparent deals. Total peace of
          mind.
        </p>

        <div className="w-full">
          {cleared && <Form isHero={true} />}
        </div>
      </div>

      {/*
        Mobile-only form card. Rendered below the image banner as its own
        white block, pulled up slightly to overlap the image bottom edge
        (matches the screenshot). Hidden on desktop — desktop form is the
        one inside the content block above, untouched.
      */}
      <div className="md:hidden relative z-10 px-4 -mt-10">
        {cleared && <Form isHero={true} />}
      </div>
    </section>
  );
}
